module.exports = __webpack_public_path__ + "static/img/home_new1.a48b031a.jpg";